<template>
    <AppSection :title="params.title?params.title:params?.messages?.title" class="section-top-volonters">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <div v-html="params.header_right" v-if="!params.header_right.title"></div>
            <div v-else>
              <a :href="params.header_right.link">{{params.header_right.title}}</a>

            </div>
        </template>
        <template #body>
            <slider-cards
                nav
                :params="{
                    slidesPerView: 6,
                    pagination: true,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 30,
                        }
                    },
                }"
            >
                <swiper-slide v-for="(item, i) in params.items" :key="i">
                    <volonter-card v-bind="item" :showRang = 'item?.showRang'/>
                </swiper-slide>
            </slider-cards>
        </template>
    </AppSection>
</template>

<script>
import AppSection from '../AppSection.vue'
import VolonterCard from '../cards/VolonterCard.vue'
import SliderCards from '../SliderCards.vue'
import { SwiperSlide } from 'swiper/vue';

export default {
    name: 'TopVolontersSection',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        AppSection,
        VolonterCard,
        SliderCards,
        SwiperSlide,
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .section-top-volonters {
        background: var(--c-secondary-300);
        .section__header,
        .section__header a {
            color: #fff;
        }
        .swiper {
            &-pagination {
                display: none;
                @include mobile {
                    display: block;
                }
                &-bullet {
                    background: var(--c-secondary-200);
                    &-active {
                        background: #fff;
                    }
                }
            }
        }

        @include tablet {
            .section__header-col-right {
                display: none;
            }
        }
    }
</style>
